import clsx from 'clsx';
import styles from './Skeleton.module.css';

interface Props {
  width?: string | number;
  height?: string | number;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
  className?: string;
}

export const Skeleton = ({ width, height, rounded = 'md', className }: Props) => {
  return (
    <div
      className={clsx(styles.skeleton, styles[`rounded-${rounded}`], className)}
      style={{ width, height }}
    />
  );
};
